exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "footer {\n    margin-bottom: 0px;\n    background-color: black;\n}\n", ""]);

